var map = {
	"./Picture1.jpg": 4675,
	"./Picture2.jpg": 6548,
	"./Picture3.jpg": 3921,
	"./Picture4.jpg": 4690,
	"./Picture5.jpg": 7359,
	"./Picture6.jpg": 3024,
	"./Picture7.jpg": 3949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3638;